module.exports = __webpack_public_path__ + "static/img/b2_footer.019e4e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b2_footer.png
// module id = FDwQ
// module chunks = 1